import LetterIcon from '@assets/icons/email.svg?react'
import PadlockImage from '@images/lock-and-key.png'
import { toastSuccess } from '@utils'
import { useForgotPasswordQry } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { type BaseSyntheticEvent, useContext, useEffect } from 'react'
import { CoreButton, CoreInput } from '../index'

import './forgottenPasswordModal.scss'

const ForgottenPasswordModal = () => {
  const { modalHide } = useContext(GlobalContext)

  const { formValues, forgotPasswordError, forgotPasswordFetching, handleSubmit } = useForgotPasswordQry(() => {
    modalHide()
    toastSuccess(
      tr('PORTAL.FORGOT_PASSWORD.SUCCESS_TITLE', 'Password recovery link was sent.'),
      tr('PORTAL.FORGOT_PASSWORD.SUCCESS_SUBTITLE', 'Please check your email.'),
      {
        className: 'forgot-password-modal-success',
        duration: 3_000
      }
    )
  })

  useEffect(() => {
    if (forgotPasswordError) {
      formValues.handleErrors(forgotPasswordError)
    }
  }, [forgotPasswordError])

  const handleFormSubmit = async (e: BaseSyntheticEvent) => {
    e.preventDefault()
    void handleSubmit()
  }

  return (
    <form onSubmit={handleFormSubmit} noValidate className='forgotten-password-modal-wrapper'>
      <img src={PadlockImage} alt='' />

      <div className='subtitle'>
        {tr('PORTAL.FORGOT_PASSWORD.SUBTITLE', "We'll send the link for you to reset your password.")}
      </div>

      <CoreInput
        data-test='email'
        label={tr('PORTAL.FORGOT_PASSWORD.EMAIL', 'Email')}
        LeftIcon={<LetterIcon />}
        maxLength={320}
        {...formValues.registerInput('email')}
        type='text'
        required
      />

      <ErrorDisplay error={forgotPasswordError} />

      <CoreButton
        fullWidth
        variation='primary-black'
        size='large'
        text={tr('PORTAL.FORGOT_PASSWORD.RESET_BUTTON', 'Reset Password')}
        isLoading={forgotPasswordFetching}
      />
    </form>
  )
}

export default ForgottenPasswordModal
